import { FadeUp, Eyebrow } from "@/lib/motion";

const BADGES = [
  { role: "Founder", org: "ZD Design" },
  { role: "Group Leader", org: "ACA Business Club" },
  { role: "Founder", org: "SEM San Diego" },
  { role: "Founder", org: "So Cal Marketing Club" },
];

export default function Founder() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative overflow-hidden border-t border-slate-200 bg-ink py-24 md:py-32"
    >
      <div className="pointer-events-none absolute -left-40 top-1/3 h-[480px] w-[480px] rounded-full bg-flame/10 blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <FadeUp>
            <div
              data-testid="founder-portrait-frame"
              className="group relative overflow-hidden rounded-2xl border border-slate-200"
            >
              <img
                src="/img/todd.webp"
                alt="Todd Meisler, Founder of ZD Design"
                className="aspect-[4/5] w-full scale-105 object-cover grayscale transition-all duration-700 group-hover:scale-100 group-hover:grayscale-0"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
              <div className="glass absolute bottom-5 left-5 rounded-xl border border-slate-200 px-5 py-4">
                <div className="font-display text-xl font-bold text-slate-900">
                  Todd Meisler
                </div>
                <div className="font-mono text-[13px] uppercase tracking-[0.22em] text-flame">
                  Founder & Lead Strategist
                </div>
              </div>
            </div>
          </FadeUp>

          <div>
            <FadeUp>
              <Eyebrow>Who you work with</Eyebrow>
              <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl">
                The person behind the{" "}
                <span className="text-flame">rankings.</span>
              </h2>
            </FadeUp>

            <FadeUp delay={0.1}>
              <p className="mt-7 text-lg leading-relaxed text-mist md:text-xl">
                Todd Meisler is an{" "}
                <strong className="font-semibold text-slate-900">
                  industry-recognized SEO specialist
                </strong>{" "}
                and the founder of ZD Design. He's spent his career{" "}
                <em>teaching search</em> — founding SEM San Diego and So Cal
                Marketing Club, speaking at conferences and group events, and
                leading the ACA Business Club group.
              </p>
              <p className="mt-5 text-lg leading-relaxed text-mist md:text-xl">
                His focus is home-service companies and small business owners:
                clear strategy, honest reporting, and websites that{" "}
                <em>earn their keep</em>.{" "}
                <strong className="font-semibold text-slate-900">
                  No account managers, no juniors
                </strong>{" "}
                — all clients work one-on-one with Todd to build and execute
                their marketing plan.
              </p>
            </FadeUp>

            <FadeUp delay={0.2}>
              <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {BADGES.map((b) => (
                  <div
                    key={b.org}
                    data-testid={`founder-badge-${b.org.toLowerCase().replace(/\s+/g, "-")}`}
                    className="flex items-center gap-4 rounded-xl border border-slate-200 bg-coal/70 px-5 py-4 transition-colors duration-300 hover:border-flame/40"
                  >
                    <span className="h-2 w-2 shrink-0 rounded-full bg-flame" />
                    <div>
                      <div className="font-mono text-[13px] uppercase tracking-[0.2em] text-faint">
                        {b.role}
                      </div>
                      <div className="font-semibold text-slate-900">{b.org}</div>
                    </div>
                  </div>
                ))}
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
